module.exports = __webpack_public_path__ + "img/commission_settlement.c8306c39.png";